import { Box, Button, Loader, SkeletonGroup, Text } from '@wix/design-system';
import { parseDomain } from '@wix/domains-serverless-interface';
import { PricingSection } from '@wix/domains-search-suite';
import React, { useState } from 'react';
import { DomainSearchGateModule } from '../../domainSearchGate.module';
import { TldOfferWidgetModule } from '../tldOfferWidget.module';
import { TldOfferPricingSkeleton } from './TldOfferPricingSkeleton';
import s from './tldOfferCard.scss';
export const TldOfferCard = _ref => {
  let domainName = _ref.domainName,
    pricing = _ref.pricing,
    _ref$isPricingLoading = _ref.isPricingLoading,
    isPricingLoading = _ref$isPricingLoading === void 0 ? false : _ref$isPricingLoading,
    onGetItClick = _ref.onGetItClick,
    dataHook = _ref.dataHook;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const tld = parseDomain(domainName).tld ?? '';
  const _useState = useState(false),
    isClickLoading = _useState[0],
    setIsClickLoading = _useState[1];
  const _useState2 = useState(false),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  const CardContainer = TldOfferWidgetModule.SDK.Layouts.CardContainer;
  const handleClick = async () => {
    setIsClickLoading(true);
    try {
      await onGetItClick();
    } finally {
      setIsClickLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: s.hoverArea,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false)
  }, /*#__PURE__*/React.createElement(CardContainer, {
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "10px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "bold"
  }, ".", tld), isPricingLoading && !(pricing != null && pricing.price) ? /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light",
    backgroundColor: "white"
  }, /*#__PURE__*/React.createElement(TldOfferPricingSkeleton, null)) : /*#__PURE__*/React.createElement(PricingSection, {
    pricing: pricing,
    tld: tld,
    domainName: domainName,
    useMobileLayout: true
  })), /*#__PURE__*/React.createElement(Box, {
    marginTop: "auto",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    priority: isHovered ? 'primary' : 'secondary',
    skin: "dark",
    fullWidth: true,
    disabled: isClickLoading,
    onClick: handleClick,
    dataHook: dataHook && `${dataHook}-button`
  }, isClickLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : t('domain_search_gate.results.cta.get_it')))));
};
//# sourceMappingURL=TldOfferCard.js.map